import styled from '@emotion/styled';
import { BOUNDING_BOX_COLORS_PRIMARY, baseBoundingBoxCssStyle } from 'constants/bounding-box';
import Moveable from 'react-moveable';

export const StyledMoveableDraggableImage = styled(Moveable)`
  // Override the z-index of Moveable so that it appears below Chakra modals
  z-index: var(--vg-zIndices-boundingBox) !important;
  // Nested bounding boxes
  .moveable-control-box {
    .moveable-line,
    .moveable-direction {
      height: 0.5px;
    }
  }
  .moveable-line.moveable-edge.moveable-direction {
    background: ${BOUNDING_BOX_COLORS_PRIMARY};
  }
  ${baseBoundingBoxCssStyle}
  .moveable-rotation-control:hover {
    background-color: var(--vg-colors-gray-100) !important;
  }
  .moveable-rotation-line {
    display: none !important;
  }
`;
